import { Component, type ErrorInfo, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { reportError } from "../lib/errorReporting";

function CrashScreen() {
  const { t } = useTranslation();
  return (
    <main className="grid min-h-screen place-items-center bg-surface p-6 text-center">
      <div className="grid max-w-sm gap-4">
        <h1 className="text-xl font-semibold text-app-ink">{t("crashTitle")}</h1>
        <p className="text-sm text-app-copy">{t("crashBody")}</p>
        <button
          type="button"
          className="rounded-md bg-accent px-4 py-3 text-sm font-semibold text-white"
          onClick={() => window.location.reload()}
        >
          {t("crashReload")}
        </button>
      </div>
    </main>
  );
}

// The last line of defence: if a screen throws while drawing, the teacher sees
// a way out instead of a blank page, and the crash is recorded.
export class ErrorBoundary extends Component<{ children: ReactNode }, { crashed: boolean }> {
  state = { crashed: false };

  static getDerivedStateFromError() {
    return { crashed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    reportError("render_crash", error, {
      component_stack: (info.componentStack || "").trim().slice(0, 800),
    });
  }

  render() {
    return this.state.crashed ? <CrashScreen /> : this.props.children;
  }
}
